module.exports = __webpack_public_path__ + "media/application/images/ui/menu-tile-5c554ac53713f57e69d161e2f087c8b1.svg";